import { useApi } from "#hooks/useApi"
import ActionPlanButtons from "#performance-evaluation/components/action-plan/ActionPlanButtons"
import { evaluationActionPlanGet } from "#performance-evaluation/services/api"
import { Box } from "@mui/material"
import { useReloadRedux } from "app/reload"
import MUIDataTable from "mui-datatables"
import { useMemo } from "react"
import { useParams } from "react-router-dom"

export default function ActionPlan() {
	const { reload } = useReloadRedux()
	const paramsUrl = useParams()
	const collaboratorId = paramsUrl["collaboratorId"]
	const params = useMemo(
		() => ({
			colaborador_id: collaboratorId,
		}),
		[collaboratorId],
	)

	const { data } = useApi(evaluationActionPlanGet, { params, autoFetch: true, reload })
	const columns = [
		{
			name: "status_name",
			label: "Estado",
		},
		{
			name: "competencia_name",
			label: "Competencia",
		},

		{
			name: "objective",
			label: "Objetivo",
		},
		{
			name: "actions",
			label: "Acciones",
		},
		{
			name: "commitment_date",
			label: "Fecha de Compromiso",
		},
		{
			name: "created_at",
			label: "Fecha de Creación",
		},

		{
			name: "buttons",
			label: " ",
			options: {
				sort: false,
				filter: false,
				print: false,

				customBodyRender: (value, tableMeta) => {
					let item = data?.plan_action[tableMeta.rowIndex]
					return <ActionPlanButtons actionPlan={item} />
				},
			},
		},
	]
	const options = {
		filterType: "checkbox",
		selectableRows: "none",
		download: false,
		print: false,
		filter: false,
		viewColumns: false,
		textLabels: {
			body: {
				noMatch: "No hay planes de acción",
			},
		},
	}
	return (
		<Box p={2}>
			<MUIDataTable data={data?.plan_action || []} columns={columns} options={options} />
		</Box>
	)
}
